module.exports = __webpack_public_path__ + "img/39_2.8e408058.png";